import {Box} from "@cjdev-internal/visual-stack";
import {Select} from "@cjdev-internal/visual-stack-x/Select";
import React, {useEffect, useState} from "react";
import {DROPDOWN_PLACEHOLDER} from "../../constants/appConstant";
import {useUserContext} from "../../context/UserContextProvider";
import {useCampaignsContext} from "../CampaignsContext/useCampaignsContext";

const SelectAllMenuList = ({id, setSelectedFilterList, optionList, clearAll}) => {
    const {userData} = useUserContext();
    const {filterData, setFilterData} = useCampaignsContext();

    const isUserDataAvailable = () => {
        return !!(userData !== undefined && userData.currentCompany);
    }
    const getDefaultFilterAdvertiser = (company) => {
        if (isUserDataAvailable()) {
            const currentCompany = company.currentCompany;
            return [{
                companyName: currentCompany.name,
                label: currentCompany.name + " (" + currentCompany.id + ")",
                type: currentCompany.type,
                value: currentCompany.id
            }]
        } else {
            return [];
        }
    }

    const defaultFilterAdvertiser = getDefaultFilterAdvertiser(userData);
    const [allSelectedValues, setAllSelectValues] = useState([]);
    const [optionValues, setOptionValues] = useState([])
    const selectAllLabel = {label: "Select All", value: "ALL"};

    useEffect(() => {
        setSelectedFilterList(allSelectedValues);
    }, [allSelectedValues])

    useEffect(() => {
        clearAllSelection();
    }, [clearAll])

    useEffect(() => {
        let optionWithoutCurrentCompany = optionList;
        if (isUserDataAvailable()) {
            const filters = {
                ...filterData,
                advertisers: [userData.currentCompany]
            }
            setFilterData(filters);
            setAllSelectValues(defaultFilterAdvertiser);
            optionWithoutCurrentCompany = optionList.filter((option) =>
                option.value !== defaultFilterAdvertiser[0].value);
        }
        setOptionValues([selectAllLabel, ...optionWithoutCurrentCompany]);
    }, [userData && userData.currentCompany, optionList])

    const clearAllSelection = () => {
        if (clearAll) {
            setAllSelectValues([])
            setOptionValues([selectAllLabel, ...optionList]);
        }
    }

    const isSelectAllLabelDisplayed = (optionValues) => {
        if (optionValues[0] !== undefined) {
            if (optionValues[0].value === selectAllLabel.value) {
                return true
            }
        }
        return false
    }

    const onChangeSelection = (value, event) => {      //select all
        //  action: "select-option"
        //  option : {value:"ALL"}
        //deselect all
        //  action: "clear"
        //select one
        //  action: "select-option"
        //  option : {value:123}
        //deselect one
        //  action: "remove-value"
        //  removedValue : {value:123}
        //deselect 'select all'
        if (event.action === "select-option" && event.option.value === "ALL") {
            setAllSelectValues(optionList);
            setOptionValues([]);
        } else if (event.action === "select-option") {
            setAllSelectValues(prevState => {
                return [...prevState, event.option];
            });
            if (optionValues.length === 2 && optionValues[0].value === selectAllLabel.value) {
                setOptionValues([])
            } else {
                setOptionValues(optionValues.filter((optionValue) => optionValue.value !== event.option.value))
            }
        } else if (event.action === "clear") {
            setAllSelectValues([])
            setOptionValues([selectAllLabel, ...optionList]);
        } else if (event.action === "remove-value") {
            setAllSelectValues(allSelectedValues.filter((optionValue) => optionValue.value !== event.removedValue.value));
            if (isSelectAllLabelDisplayed(optionValues)) {
                setOptionValues([...optionValues, event.removedValue])
            } else {
                setOptionValues([selectAllLabel, ...optionValues, event.removedValue])
            }
        }
    }

    return (
        <Box direction="column" className="badges-filter">
            <Select
                id={id}
                isMulti
                options={optionValues}
                placeholder={DROPDOWN_PLACEHOLDER}
                value={allSelectedValues}
                onChange={onChangeSelection}
            />
        </Box>
    );
}

export default SelectAllMenuList;